import { Platform, StyleSheet } from 'react-native';
import { tokens } from '../crop-circle/tokens';

export const preferencesStyles = StyleSheet.create({
  contentContainer: {
    paddingTop: tokens.spacing.lg,
    gap: tokens.spacing['2xl'],
    marginBottom: tokens.spacing.lg,
    ...Platform.select({
      web: {
        paddingTop: 0,
      },
    }),
  },
  heading: {
    ...tokens.typography.body.mediumEmphasised,
    color: tokens.colors.neutral[800],
    marginBottom: tokens.spacing.md,
  },
  // Section title shared by the Crop Circle notification screens, matching the
  // activity filter page (filter/filterContent.tsx `sectionTitle`) so all the
  // settings/filter section headers read consistently.
  sectionTitle: {
    ...tokens.typography.label.largeEmphasised,
    fontWeight: tokens.typography.label.largeEmphasised.fontWeight,
    color: tokens.colors.neutral[600],
    marginBottom: tokens.spacing.md,
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
  },
  contentFieldFormCropCircle: {
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: tokens.colors.brand.white,
    borderRadius: tokens.borderRadius.xl,
    flexShrink: 1,
    ...Platform.select({
      web: {
        borderRadius: tokens.borderRadius.lg,
      },
    }),
  },
});
